import { Component, OnDestroy, OnInit } from '@angular/core';
import { JobService } from '../../services/job.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { LOCAL_STORAGE } from '../../constants/local-storage.constants';
import { Rider } from '../../models/rider.model';
import { JobStatus } from '../../models/job.model';
import { Router } from '@angular/router';
import { NotificationSoundService } from '../../services/notification-sound.service';
@Component({
  selector: 'app-notify-rider',
  templateUrl: './notify-rider.component.html',
  styleUrls: ['./notify-rider.component.scss'],
})
export class NotifyRiderComponent implements OnInit {
  rider: Rider;
  potentialRiderJob: any;
  JobStatus = JobStatus;
  constructor(
    private jobService: JobService,
    private localStorage: LocalStorageService,
    private router: Router,
    private notificationSound: NotificationSoundService
  ) {
    this.rider = this.localStorage.getItem(LOCAL_STORAGE.RIDER);
  }

  ngOnInit() {
    this.jobService
      .getPotentialJobByRiderId(this.rider.riderId)
      .subscribe((data) => {
        this.potentialRiderJob = data;
        console.log('POTENTIALRIDER', this.potentialRiderJob, this.rider);
        if (this.potentialRiderJob?.jobStatus === JobStatus.JOB_CREATED) {
          this.notificationSound.playNotificationSound();
        } else {
          this.notificationSound.stopNotificationSound();
        }
      });
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
}
